import React, { useState } from 'react';
import Button from 'components/commercetools-ui/atoms/button';
import Input from 'components/commercetools-ui/atoms/input';
import { useAdyenCheckout } from 'components/commercetools-ui/organisms/checkout/provider';
import AppliedGiftcards from 'components/commercetools-ui/organisms/order-payment-section/components/appliedGiftCards';
import { useFormat } from 'helpers/hooks/useFormat';
import { useCart } from 'frontastic';
import GiftCardErrorMessage from './error-messages';
import PaymentHelper from '../../helper';

const Givex = () => {
  const { formatMessage } = useFormat({ name: 'common' });
  const { data, applyGiftcard } = useCart();
  const [input, setInput] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const paymentHelper = PaymentHelper();

  const onApply = () => {
    setProcessing(true);
    applyGiftcard(input, data?.sum?.centAmount)
      .then(() => {
        setErrorMessage('');
        paymentHelper.freezeCartForPayment(data);
      })
      .catch((error) => {
        setErrorMessage(error.message);
      })
      .finally(() => {
        setProcessing(false);
        setInput('');
      });
  };

  const [processing, setProcessing] = useState(false);

  return (
    <div className="p-24">
      <h2 className="mb-18 text-lg font-normal">Gift Card</h2>
      <p className="mb-8 text-sm font-light">Would you like to redeem an American Golf gift card or e-voucher?</p>
      <div className="block items-center gap-8 md:flex">
        <div>
          <Input
            name="giftcardNumber"
            className="!min-w-[280px] text-[16px]"
            labelPosition="inline"
            placeholder={formatMessage({ id: 'giftcardNumber', defaultMessage: 'Giftcard number' })}
            onChange={(e) => setInput(e.target.value?.replace(/ /g, ''))}
            value={input}
          />
        </div>
        <Button
          variant="primary"
          type="submit"
          onClick={onApply}
          loading={processing}
          className="mt-10 w-full md:mt-0 md:w-auto"
        >
          {formatMessage({ id: 'apply.giftcard', defaultMessage: 'Apply Giftcard' })}
        </Button>
      </div>
      <p className="mt-8 text-sm text-ag_color-red">
        {errorMessage && errorMessage === 'unexpectedError'
          ? formatMessage({
              id: 'apply.giftcard.common.error',
              defaultMessage:
                'Unfortunately, we were unable to take payment for this order and no payment has been taken. Please review your chosen payment methods.',
            })
          : GiftCardErrorMessage[errorMessage] ?? errorMessage}
      </p>

      <AppliedGiftcards />
    </div>
  );
};

export default Givex;
